import styled from 'styled-components';

export const LanguageSwitcherWrapper = styled.div`
  display: flex;
  gap: 10px;
  color: var(--textAndLabels-tertiary);
`;

export const LanguageOption = styled.div<{
  $isSelected: boolean;
}>`
  cursor: pointer;
  color: ${({ $isSelected }) =>
    $isSelected ? 'var(--switcher-open)' : 'var(--textAndLabels-tertiary)'};
  transition: color 0.3s ease;

  &:hover {
    color: ${({ $isSelected }) => !$isSelected && 'var(--custom-yellow)'};
  }
`;

export const Separator = styled.span`
  user-select: none;
`;
